import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import SolarPanel from '../../../../assets/solar-panel.svg';
import WindTurbine from '../../../../assets/wind-turbine.svg';
import { mixinRobotoMedium, mixinRobotoRegular } from '../../../../styles';

export const NegotiationTileStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }

  .negotiation {
    padding: 6px 8px 7px 10px;
    font-size: 11px;
    color: #b8b8b8;
    border-left: 3px solid;
    margin-bottom: 4px;
    margin-left: 3px;
    position: relative;
    cursor: pointer;
    ${mixinRobotoRegular}
  }

  .negotiation.selected {
    cursor: auto;
    background-color: rgb(255 255 255 / 7%);
  }

  .negotiation .header {
    padding-bottom: 5px;
    font-size: 12px;
    color: var(--white);
    ${mixinRobotoMedium()}
  }

  .negotiation.in-progress {
    border-color: rgb(255 182 96 / 100%);
  }

  .negotiation.rejected,
  .negotiation.traded-away {
    border-color: var(--error);
  }

  .negotiation.successful,
  .negotiation.pending-execution,
  .negotiation.in-progress-arteria,
  .negotiation.requires-confirmation,
  .negotiation.confirmed-awaiting-buyer,
  .negotiation.review-execution-checklist,
  .negotiation.ready-for-trade-execution,
  .negotiation.pending-execution-timer,
  .negotiation.executed-awaiting-buyer,
  .negotiation.executed-awaiting-seller,
  .negotiation.expired,
  .negotiation.buyer-deleted,
  .negotiation.seller-deleted,
  .negotiation.confirmed-awaiting-seller {
    border-color: var(--completed);
  }

  .technology-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 7px;
    top: 7px;
  }
`;
